import { render, staticRenderFns } from "./deviceTestList.vue?vue&type=template&id=98af6cf6&scoped=true&"
import script from "./deviceTestList.vue?vue&type=script&lang=js&"
export * from "./deviceTestList.vue?vue&type=script&lang=js&"
import style0 from "./deviceTestList.vue?vue&type=style&index=0&id=98af6cf6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98af6cf6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/deploy/iot-product-tool/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98af6cf6')) {
      api.createRecord('98af6cf6', component.options)
    } else {
      api.reload('98af6cf6', component.options)
    }
    module.hot.accept("./deviceTestList.vue?vue&type=template&id=98af6cf6&scoped=true&", function () {
      api.rerender('98af6cf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/xiazeng/deviceTestList.vue"
export default component.exports